// extracted by mini-css-extract-plugin
module.exports = {"channelContainer":"channels_channelContainer__tNRuB"};